// src/antdviews/LogsView.tsx

// 日志管理页面

import axios from 'axios'
import React from 'react'
import { Layout, message } from 'antd'
import { withTranslation, WithTranslation } from 'react-i18next'

import Header from './components/Header'
import Sidebar from './components/Sidebar'
import { getSourceName, getSourceName4Download, ROLE } from '../services/Macro'
import { Global } from '../services/Global'
import { browserUtil } from '../utils/BrowserUtil'
import LogsMgmtContent, { LogItem, LogsData } from './components/LogsMgmtContent'
import { encrypUtil } from '../utils/EncrypUtil'
import { UserMgmtApi } from '../services/Api'
import { strUtil } from '../utils/StrUtil'

interface LogsViewState {
    showWarn: boolean
    showConfirm: boolean
    warnTitle: string
    warnInfo: string
    confirmOp: () => void
    logs: LogsData
    loginName: string
    logSize: number
    logPage: number
}

const CLS_NAME = `LogsView`;

class LogsView extends React.Component<WithTranslation, LogsViewState> {
    state: LogsViewState = {
        showWarn: false,
        showConfirm: false,
        warnTitle: '本地错误',
        warnInfo: '参数错误',
        confirmOp: () => {
            console.log('do nothing!')
        },
        logs: { list: [], totalPages: 0 },
        loginName: '',
        logSize: 10,
        logPage: 1,
    }

    componentWillMount() {
        Global.isMobile = browserUtil.checkMobile()
    }

    componentDidMount() {
        // 直接调用接口获取调试日志
        this.requestLogs()
    }

    requestLogs = async () => {
        const DEBUG = true;
        const TAG = `${CLS_NAME}.requestLogs() - `;
        const uuid = 'system';
        const token = localStorage.getItem('token') || null;
        const lang = localStorage.getItem('lang') || 'zh_CN';

        const requestData = {
            role: ROLE.SUPER,
            token,
            uuid,
            lang: lang.split('_')[0],
            page: this.state.logPage,
            size: this.state.logSize,
        };

        try {
            DEBUG && console.log(TAG, `requestData:\n`, requestData);
            const params = await encrypUtil.encodeRequestRsa(requestData);
            DEBUG && console.log(TAG, `params:\n`, params);

            const response = await axios.post(UserMgmtApi.SUPER_GET_LOG_LIST, params);
            DEBUG && console.log(TAG, `获取日志列表:\n`, response.data.data);

            const logs = response.data.data as LogsData;
            this.handleLogs(logs);

            this.setState({ logs });
        } catch (error) {
            console.error(TAG, error);
            message.error('日志获取失败');
        }
    }

    handleLogs = (logs: LogsData) => {
        const logPages: number[] = []
        for (let i = 0; i < (logs.totalPages || 0); i++) {
            logPages.push(i + 1)
        }

        logs.pages = logPages

        // 记录当前连续相同日期的起始索引
        let startIndex = 0

        logs.list.forEach((log: LogItem, index: number) => {
            const date = `${log.date || ''}`.split('-').join('')
            const source = typeof log.source === 'number'
                ? log.source
                : Number(log.source || 0)

            const sourceStr4Download = getSourceName4Download(source);
            const sourceStr = `_${getSourceName(source)}`

            log.filePath = `${log.uuid || ''}${sourceStr4Download}_${date}.log`
            log.fileName = `${log.uuid || ''}${sourceStr}_${date}.log`
            log.size = strUtil.toM(typeof log.size === 'number' ? log.size : Number(log.size || 0))

            const updateTime = typeof log.updateTime === 'number'
                ? log.updateTime
                : Number(log.updateTime || 0)

            log.updateTime = strUtil.formatTime(updateTime)

            // 默认初始化 rowspan 为 1，hideDate 为 false
            log.rowspan = 1
            log.hideDate = false

            // 判断日期是否发生变化
            const prevLog = index > 0 ? logs.list[index - 1] : null

            if (prevLog && log.date === prevLog.date) {
                // 日期相同：隐藏当前行
                log.hideDate = true
            } else {
                // 日期不同（或第一行）：说明上一组日期结束了，计算上一组的合并行数
                if (index > startIndex) {
                    const span = index - startIndex
                    logs.list[startIndex].rowspan = span
                }
                // 更新新的起始索引
                startIndex = index
            }

            // 处理最后一行：如果最后几行日期相同，需要在循环结束时结算
            if (index === logs.list.length - 1 && index >= startIndex) {
                const span = index - startIndex + 1
                logs.list[startIndex].rowspan = span
            }
        })
    }

    changeLogList = (size: number, page: number) => {
        this.setState(
            {
                logSize: size,
                logPage: page,
            },
            this.requestLogs
        )
    }

    changeLang = () => {
    }

    render() {
        const { t, i18n } = this.props

        return (
            <section className="body">
                <Header
                    trans={t}
                    i18n={i18n}
                    loginName={this.state.loginName}
                    changeLang={this.changeLang}
                />

                <Layout>
                    <Sidebar selectMenu="logs" trans={t} />

                    <LogsMgmtContent
                        logs={this.state.logs}
                        trans={t}
                        changeLogList={this.changeLogList}
                    />
                </Layout>
            </section>
        )
    }
}

export const LogsPage = withTranslation()(LogsView)
